import 'js/src/libs/set-webpack-nonce';
import 'js/src/libs/page-initialization';
import 'bootstrap';

import 'css/src/limitless-deprecated/deprecated-core2.css';

import ShareVideoPage from 'js/src/components/share-video';
import { getRootReducer } from 'js/src/entry-points/root-reducers/share-video-reducers';
import { initCookieConsent } from 'js/src/libs/cookie-consent';
import { ErrorReporter, Project } from 'js/src/libs/error-reporter';
import { createReduxStore, renderWithRedux } from 'js/src/libs/redux-utils';
import WebSocketClient from 'js/src/libs/websocket-client';

initCookieConsent();
ErrorReporter.init(Project.FRONTEND);
if (window.SERVER.USER) {
    new WebSocketClient();
}

const store = createReduxStore(getRootReducer());

renderWithRedux(ShareVideoPage, store);
